function IGuideViewer(element) {
  this.element = element;
  this.iframe = this.element ? this.element.contentWindow : null;
  this.listeners = [];
  this.readyPromiseResolve = null;
  this._onMessageCb = this._onMessage.bind(this);
  this.info = null;

  if (!this.iframe) {
    throw new Error('iGUIDE API error: iframe does not exist');
  }

  window.addEventListener('message', this._onMessageCb);

  var that = this;
  this.readyPromise = new window.Promise(function (resolve, reject) {
    if (that.iframe.closed) {
      reject(new Error('iGUIDE API error: iframe is closed'));
      that.disconnect();
      return;
    }

    that.readyPromiseResolve = resolve;

    try {
      that.iframe.postMessage({ctrl: 'ping'}, '*');
    } catch (err) {
      reject(err);
      that.disconnect();
    }
  });

  this.tour = {
    // eslint-disable-next-line no-extra-parens
    move: (function (position, camera, transition) {
      var data = {
        action: 'tour:move',
        position: position,
        camera: camera,
        transition: transition,
      };
      this.iframe.postMessage(data, '*');
    }).bind(this),
    // eslint-disable-next-line no-extra-parens
    moveCamera: (function (camera) {
      var data = {
        action: 'tour:camera-move',
        camera: camera,
      };
      this.iframe.postMessage(data, '*');
    }).bind(this),
    // eslint-disable-next-line no-extra-parens
    floorplanResize: (function (state) {
      var data = {
        action: 'tour:floorplan-resize',
        state: state,
      };
      this.iframe.postMessage(data, '*');
    }).bind(this),
  };
}

IGuideViewer.prototype.getMetaInfo = function () {
  return this.info;
};

IGuideViewer.prototype.ready = function () {
  return this.readyPromise;
};

IGuideViewer.prototype.disconnect = function () {
  window.removeEventListener('message', this._onMessageCb);
  this.listeners = [];
  this.readyPromise = null;
  this.readyPromiseResolve = null;
};

IGuideViewer.prototype._onMessage = function (e) {
  if (e.source !== this.iframe) { return; }

  if (e.data && e.data.ctrl) {
    if ((e.data.ctrl === 'ready' || e.data.ctrl === 'pong') &&
      this.readyPromiseResolve) {
      if (e.data.info) {
        this.info = e.data.info;
      }
      this.readyPromiseResolve();
      this.readyPromiseResolve = null;
    }
    return;
  }

  if (e.data && e.data.event) {
    var listener;
    for (var i = 0; i < this.listeners.length; i++) {
      listener = this.listeners[i];
      if (listener.event === e.data.event) {
        listener.cb.apply(null, e.data.args);
      }
    }
  }
};

IGuideViewer.prototype.addEventListener = function (event, cb) {
  this.listeners.push({
    event: event,
    cb: cb,
  });
};

IGuideViewer.prototype.removeEventListener = function (event, cb) {
  var listener;
  for (var i = this.listeners.length - 1; i >= 0; i--) {
    listener = this.listeners[i];
    if (listener.event === event && listener.cb === cb) {
      this.listeners.splice(i, 1);
    }
  }
};

// eslint-disable-next-line no-undef
module.exports = IGuideViewer;
